<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12 col-lg-12">

      <div class="row">
        <div class="form-field col-12">
          <p-floatlabel variant="on" class=" mb">
            <p-select id="action-name" [style]="{'width': '100%'}"
                        [options]="meta?.actionNameList | formatSelectItemEnum" formControlName="actionName"
                        [autoDisplayFirst]="false"
                        optionLabel="label"
                        optionValue="value"
                        formInlineError="company.subscription-type.actions-list.errors" data-testid="action-name-select">
            </p-select>

            <label for="action-name">
              {{'company.subscription-type.actions-list.inputs.actionName' | translate}} *
            </label>
          </p-floatlabel>
        </div>

        <div class="form-field col-12">
          <p-floatlabel variant="on" class=" mb">
            <p-inputNumber [maxFractionDigits]="0"
                           [useGrouping]="false"
                           class="w-100"
                           formControlName="actionCost"
                           formInlineError="company.subscription-type.actions-list.errors"
                           id="action-cost"
                           inputStyleClass="w-100"
                           locale="en-US"
                           styleClass="w-100" data-testid="action-cost-input">

            </p-inputNumber>
            <label for="action-cost">
              {{'company.subscription-type.actions-list.inputs.actionCost' | translate}} *
            </label>
          </p-floatlabel>
        </div>

        <div class="form-field col-12">
          <p-floatlabel variant="on" class=" mb">
            <p-inputNumber [maxFractionDigits]="0"
                           [useGrouping]="false"
                           class="w-100"
                           formControlName="monthlyIncludedAmount"
                           id="monthly-included-amount"
                           inputStyleClass="w-100"
                           locale="en-US"
                           styleClass="w-100" data-testid="monthly-included-amount-input"></p-inputNumber>
            <label for="monthly-included-amount">
              {{'company.subscription-type.actions-list.inputs.monthlyIncludedAmount' | translate}}
            </label>
          </p-floatlabel>
        </div>

        <div class="form-field col-12">
          <p-checkbox formControlName="allowExtra"
                      [binary]="true"
                      inputId="allow-extra"
                      data-testid="allow-extra-checkbox">
          </p-checkbox>
          <label for="allow-extra">{{ 'company.subscription-type.actions-list.inputs.allowExtra' | translate }}</label>
        </div>
      </div>

    </div>
  </div>
</form>


